import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, withCtx as _withCtx, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "media-transformer" }
const _hoisted_2 = { class: "resize-button" }
const _hoisted_3 = { class: "video-backdrop" }
const _hoisted_4 = ["poster"]
const _hoisted_5 = ["src", "type"]
const _hoisted_6 = { class: "video-controls-container" }
const _hoisted_7 = { class: "rewind-controls" }
const _hoisted_8 = { class: "play-controls" }
const _hoisted_9 = { class: "rewind-controls" }
const _hoisted_10 = { class: "video-range" }
const _hoisted_11 = { class: "video-settings-button" }
const _hoisted_12 = {
  class: "pdf-video-container",
  id: "pdf-video-container"
}
const _hoisted_13 = {
  key: 0,
  class: "spinner-wrapper"
}
const _hoisted_14 = {
  key: 1,
  class: "pdf-video-wrapper",
  id: "pdf-video-wrapper"
}
const _hoisted_15 = { class: "ban-container" }
const _hoisted_16 = {
  key: 2,
  class: "pdf-video-wrapper",
  id: "pdf-video-wrapper"
}
const _hoisted_17 = { class: "ban-container" }
const _hoisted_18 = { class: "links-container" }
const _hoisted_19 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_icon = _resolveComponent("ion-icon")!
  const _component_ion_spinner = _resolveComponent("ion-spinner")!
  const _component_vue_slider = _resolveComponent("vue-slider")!
  const _component_ion_button = _resolveComponent("ion-button")!
  const _component_ion_label = _resolveComponent("ion-label")!
  const _component_ion_toggle = _resolveComponent("ion-toggle")!
  const _component_ion_item = _resolveComponent("ion-item")!
  const _component_ion_select_option = _resolveComponent("ion-select-option")!
  const _component_ion_select = _resolveComponent("ion-select")!
  const _component_ion_content = _resolveComponent("ion-content")!
  const _component_ion_popover = _resolveComponent("ion-popover")!
  const _component_ion_img = _resolveComponent("ion-img")!
  const _component_ion_page = _resolveComponent("ion-page")!

  return (_openBlock(), _createBlock(_component_ion_page, null, {
    default: _withCtx(() => [
      _createVNode(_component_ion_content, {
        class: _normalizeClass(['main-video-content', !_ctx.isMobile ? 'split-video' : '']),
        fullscreen: true,
        slot: "fixed",
        "scroll-y": false
      }, {
        default: _withCtx(() => [
          _cache[29] || (_cache[29] = _createElementVNode("div", { class: "release-safe-area" }, null, -1)),
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("div", {
              class: _normalizeClass([
          'media-container',
          _ctx.isFullScreen ? 'video-fullscreen-mode' : '',
        ])
            }, [
              _createElementVNode("div", {
                class: _normalizeClass([
            'video-container',
            !_ctx.isFullScreen
              ? 'portrait-video-container'
              : 'landscape-video-container',
          ])
              }, [
                _withDirectives(_createElementVNode("div", _hoisted_2, [
                  _createVNode(_component_ion_icon, {
                    icon: _ctx.resizeOutline,
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.openWebFullScreen()))
                  }, null, 8, ["icon"])
                ], 512), [
                  [_vShow, !_ctx.isMobile]
                ]),
                _withDirectives(_createElementVNode("div", _hoisted_3, null, 512), [
                  [_vShow, _ctx.showBackdrop]
                ]),
                _createElementVNode("div", {
                  class: "touch-controls-area",
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.showControls()))
                }),
                _createElementVNode("div", {
                  class: _normalizeClass(['skip-time-area', 'skip-time-area-left', !_ctx.showBackdrop ? 'skip-time-area-transparent' : '']),
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.onRewindClick(-15)))
                }, [
                  _withDirectives(_createElementVNode("span", null, "-15s", 512), [
                    [_vShow, !_ctx.isPlayBack]
                  ]),
                  _withDirectives(_createVNode(_component_ion_icon, { icon: _ctx.playBack }, null, 8, ["icon"]), [
                    [_vShow, _ctx.isPlayBack]
                  ])
                ], 2),
                _createElementVNode("div", {
                  class: _normalizeClass(['skip-time-area', 'skip-time-area-right', !_ctx.showBackdrop ? 'skip-time-area-transparent' : '']),
                  onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.onRewindClick(15)))
                }, [
                  _withDirectives(_createElementVNode("span", null, "+15s", 512), [
                    [_vShow, !_ctx.isPlayForward]
                  ]),
                  _withDirectives(_createVNode(_component_ion_icon, { icon: _ctx.playForward }, null, 8, ["icon"]), [
                    [_vShow, _ctx.isPlayForward]
                  ])
                ], 2),
                _createElementVNode("video", {
                  oncontextmenu: "return false;",
                  preload: "metadata",
                  "webkit-playsinline": "webkit-playsinline",
                  playsinline: "",
                  ref: "videoRef",
                  autoPictureInPicture: "true",
                  controlsList: "nodownload",
                  crossorigin: "anonymous",
                  poster: _ctx.programLogo || _ctx.getProgramImage(_ctx.releaseEntity.programShortName)
                ,
                  class: _normalizeClass([_ctx.videoMirrorMode ? 'video-mirror' : ''])
                }, [
                  _createElementVNode("source", {
                    src: _ctx.trackPath,
                    type: _ctx.trackPath.endsWith('m3u8')
                ? 'application/x-mpegURL'
                : 'video/mp4'
                
                  }, null, 8, _hoisted_5)
                ], 10, _hoisted_4),
                _withDirectives(_createElementVNode("div", _hoisted_6, [
                  _createElementVNode("div", _hoisted_7, [
                    _createVNode(_component_ion_icon, {
                      icon: _ctx.playSkipBack,
                      class: _normalizeClass([_ctx.currentVideoIdx === 0 ? 'disabled-button' : '']),
                      onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.prevTrack()))
                    }, null, 8, ["icon", "class"])
                  ]),
                  _createElementVNode("div", _hoisted_8, [
                    _withDirectives(_createVNode(_component_ion_icon, {
                      icon: _ctx.play,
                      onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.playerControls(true)))
                    }, null, 8, ["icon"]), [
                      [_vShow, !_ctx.videoPlaying && !_ctx.videoWaiting]
                    ]),
                    _withDirectives(_createVNode(_component_ion_icon, {
                      icon: _ctx.pause,
                      onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.playerControls(false)))
                    }, null, 8, ["icon"]), [
                      [_vShow, _ctx.videoPlaying && !_ctx.videoWaiting]
                    ]),
                    _withDirectives(_createVNode(_component_ion_spinner, { name: "bubbles" }, null, 512), [
                      [_vShow, _ctx.videoWaiting]
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_9, [
                    _createVNode(_component_ion_icon, {
                      icon: _ctx.playSkipForward,
                      class: _normalizeClass([
                  _ctx.currentVideoIdx === _ctx.videoList.length - 1
                    ? 'disabled-button'
                    : '',
                ]),
                      onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.nextTrack()))
                    }, null, 8, ["icon", "class"])
                  ])
                ], 512), [
                  [_vShow, _ctx.showBackdrop]
                ]),
                _createElementVNode("div", _hoisted_10, [
                  _withDirectives(_createVNode(_component_vue_slider, {
                    class: "buffered-video-range",
                    lazy: true,
                    modelValue: _ctx.playerRangeCurrentValue,
                    "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.playerRangeCurrentValue) = $event)),
                    min: 0,
                    max: _ctx.playerRangeMaxValue,
                    onDragging: _ctx.rangeDragging,
                    onDragStart: _cache[9] || (_cache[9] = ($event: any) => (_ctx.rangeDragStart())),
                    onDragEnd: _cache[10] || (_cache[10] = ($event: any) => (_ctx.rangeDragEnd())),
                    tooltip: "none",
                    "drag-on-click": true
                  }, null, 8, ["modelValue", "max", "onDragging"]), [
                    [_vShow, _ctx.showBackdrop]
                  ])
                ]),
                _withDirectives(_createElementVNode("div", { class: "video-current-time" }, _toDisplayString(_ctx.currentTrackCurrentTime), 513), [
                  [_vShow, _ctx.showBackdrop]
                ]),
                _withDirectives(_createElementVNode("div", { class: "video-total-time" }, _toDisplayString(_ctx.currentTrackTotalTime), 513), [
                  [_vShow, _ctx.showBackdrop]
                ]),
                _withDirectives(_createElementVNode("div", _hoisted_11, [
                  _createVNode(_component_ion_button, { id: "trigger-video-settings" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_icon, {
                        icon: _ctx.settings,
                        slot: "icon-only"
                      }, null, 8, ["icon"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_ion_popover, {
                    trigger: "trigger-video-settings",
                    class: "video-settings-container",
                    side: "left",
                    mode: "ios",
                    arrow: false
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_content, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_item, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_ion_label, null, {
                                default: _withCtx(() => [...(_cache[20] || (_cache[20] = [
                                  _createTextVNode("Зеркально", -1)
                                ]))]),
                                _: 1
                              }),
                              _createVNode(_component_ion_toggle, {
                                onIonChange: _cache[11] || (_cache[11] = ($event: any) => (_ctx.setMirrorMode($event))),
                                checked: _ctx.videoMirrorMode,
                                mode: "md"
                              }, null, 8, ["checked"])
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_ion_item, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_ion_label, null, {
                                default: _withCtx(() => [...(_cache[21] || (_cache[21] = [
                                  _createTextVNode("Скорость", -1)
                                ]))]),
                                _: 1
                              }),
                              _createVNode(_component_ion_select, {
                                value: _ctx.videoPlaybackRate,
                                interface: "popover",
                                mode: "ios",
                                onIonChange: _ctx.changeVideoRate,
                                "selected-text": _ctx.videoPlaybackRate + 'x'
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_ion_select_option, {
                                    "interface-options": _ctx.selectOptions,
                                    value: "1"
                                  }, {
                                    default: _withCtx(() => [...(_cache[22] || (_cache[22] = [
                                      _createTextVNode("1x", -1)
                                    ]))]),
                                    _: 1
                                  }, 8, ["interface-options"]),
                                  _createVNode(_component_ion_select_option, {
                                    "interface-options": _ctx.selectOptions,
                                    value: "1.25"
                                  }, {
                                    default: _withCtx(() => [...(_cache[23] || (_cache[23] = [
                                      _createTextVNode("1.25x", -1)
                                    ]))]),
                                    _: 1
                                  }, 8, ["interface-options"]),
                                  _createVNode(_component_ion_select_option, {
                                    "interface-options": _ctx.selectOptions,
                                    value: "1.5"
                                  }, {
                                    default: _withCtx(() => [...(_cache[24] || (_cache[24] = [
                                      _createTextVNode("1.5x", -1)
                                    ]))]),
                                    _: 1
                                  }, 8, ["interface-options"]),
                                  _createVNode(_component_ion_select_option, {
                                    "interface-options": _ctx.selectOptions,
                                    value: "1.75"
                                  }, {
                                    default: _withCtx(() => [...(_cache[25] || (_cache[25] = [
                                      _createTextVNode("1.75x", -1)
                                    ]))]),
                                    _: 1
                                  }, 8, ["interface-options"]),
                                  _createVNode(_component_ion_select_option, {
                                    "interface-options": _ctx.selectOptions,
                                    value: "2"
                                  }, {
                                    default: _withCtx(() => [...(_cache[26] || (_cache[26] = [
                                      _createTextVNode("2x", -1)
                                    ]))]),
                                    _: 1
                                  }, 8, ["interface-options"])
                                ]),
                                _: 1
                              }, 8, ["value", "onIonChange", "selected-text"])
                            ]),
                            _: 1
                          }),
                          _withDirectives(_createVNode(_component_ion_item, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_ion_label, null, {
                                default: _withCtx(() => [...(_cache[27] || (_cache[27] = [
                                  _createTextVNode("Качество", -1)
                                ]))]),
                                _: 1
                              }),
                              _createVNode(_component_ion_select, {
                                value: _ctx.videoQuality,
                                interface: "popover",
                                mode: "ios",
                                onIonChange: _ctx.changeVideoQuality,
                                "selected-text": _ctx.videoQualityDic.get(_ctx.videoQuality)
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_ion_select_option, {
                                    "interface-options": _ctx.selectOptions,
                                    value: "lq"
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(_ctx.videoQualityDic.get("lq")), 1)
                                    ]),
                                    _: 1
                                  }, 8, ["interface-options"]),
                                  _createVNode(_component_ion_select_option, {
                                    "interface-options": _ctx.selectOptions,
                                    value: "hq"
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(_ctx.videoQualityDic.get("hq")), 1)
                                    ]),
                                    _: 1
                                  }, 8, ["interface-options"])
                                ]),
                                _: 1
                              }, 8, ["value", "onIonChange", "selected-text"])
                            ]),
                            _: 1
                          }, 512), [
                            [_vShow, false]
                          ]),
                          _withDirectives(_createVNode(_component_ion_item, {
                            onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.setPipMode())),
                            button: ""
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_ion_label, null, {
                                default: _withCtx(() => [...(_cache[28] || (_cache[28] = [
                                  _createTextVNode("PiP", -1)
                                ]))]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }, 512), [
                            [_vShow, _ctx.pipModeAvailable]
                          ])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ], 512), [
                  [_vShow, _ctx.showBackdrop]
                ])
              ], 2),
              _withDirectives(_createElementVNode("div", {
                class: _normalizeClass(_ctx.isMobile ? 'video-playlist' : 'video-playlist-web')
              }, [
                _createVNode(_component_ion_select, {
                  interface: "popover",
                  mode: "ios",
                  modelValue: _ctx.currentVideoIdx,
                  "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.currentVideoIdx) = $event)),
                  value: _ctx.currentVideoIdx,
                  selectedText: _ctx.currentVideoName,
                  onIonChange: _cache[14] || (_cache[14] = ($event: any) => (_ctx.onSelectVideoTrack()))
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.videoList, (video, idx) => {
                      return (_openBlock(), _createBlock(_component_ion_select_option, {
                        "interface-options": _ctx.selectOptions,
                        key: video.id,
                        value: idx
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.formatVideoName(video.name)), 1)
                        ]),
                        _: 2
                      }, 1032, ["interface-options", "value"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["modelValue", "value", "selectedText"])
              ], 2), [
                [_vShow, _ctx.showBackdrop]
              ])
            ], 2),
            _withDirectives(_createElementVNode("div", _hoisted_12, [
              (_ctx.guideNumPages < 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                    _createVNode(_component_ion_spinner, { name: "lines" })
                  ]))
                : _createCommentVNode("", true),
              (_ctx.guideNumPages >= 0 && !_ctx.releaseEntity.guideOffline)
                ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.guideNumPages, (page) => {
                      return (_openBlock(), _createBlock(_component_ion_img, {
                        key: page,
                        src: `${_ctx.guidePath}/${page > 9 ? page : '0' + page}${_ctx.guideToken ? '?token=' + encodeURIComponent(_ctx.guideToken) : ''}`,
                        id: `video-guide-page-${page}`,
                        onClick: _cache[15] || (_cache[15] = ($event: any) => (_ctx.setLinksContainerVisibility()))
                      }, null, 8, ["src", "id"]))
                    }), 128)),
                    _withDirectives(_createElementVNode("div", _hoisted_15, [
                      _createVNode(_component_ion_icon, {
                        slot: "icon-only",
                        icon: _ctx.ban
                      }, null, 8, ["icon"])
                    ], 512), [
                      [_vShow, _ctx.guideNumPages == 0]
                    ]),
                    _withDirectives(_createVNode(_component_ion_button, {
                      onClick: _cache[16] || (_cache[16] = ($event: any) => (_ctx.scrollTop())),
                      class: "scroll-top-btn"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_ion_icon, {
                          slot: "icon-only",
                          icon: _ctx.arrowUpOutline
                        }, null, 8, ["icon"])
                      ]),
                      _: 1
                    }, 512), [
                      [_vShow, _ctx.showScrollTop]
                    ])
                  ]))
                : _createCommentVNode("", true),
              (_ctx.guideNumPages >= 0 && _ctx.releaseEntity.guideOffline)
                ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.guidePages, (page, idx) => {
                      return (_openBlock(), _createBlock(_component_ion_img, {
                        class: "guide-page",
                        key: page.name,
                        src: `${_ctx.guidePath}/${page.name}${_ctx.guideToken ? '?token=' + encodeURIComponent(_ctx.guideToken) : ''}`,
                        id: `guide-page-${idx + 2}`,
                        onClick: _cache[17] || (_cache[17] = ($event: any) => (_ctx.setLinksContainerVisibility()))
                      }, null, 8, ["src", "id"]))
                    }), 128)),
                    _withDirectives(_createElementVNode("div", _hoisted_17, [
                      _createVNode(_component_ion_icon, {
                        slot: "icon-only",
                        icon: _ctx.ban
                      }, null, 8, ["icon"])
                    ], 512), [
                      [_vShow, _ctx.guideNumPages == 0]
                    ]),
                    _withDirectives(_createVNode(_component_ion_button, {
                      onClick: _cache[18] || (_cache[18] = ($event: any) => (_ctx.scrollTop())),
                      class: "scroll-top-btn"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_ion_icon, {
                          slot: "icon-only",
                          icon: _ctx.arrowUpOutline
                        }, null, 8, ["icon"])
                      ]),
                      _: 1
                    }, 512), [
                      [_vShow, _ctx.showScrollTop]
                    ])
                  ]))
                : _createCommentVNode("", true),
              _withDirectives(_createElementVNode("div", _hoisted_18, [
                _createElementVNode("div", {
                  class: "guide-link",
                  onClick: _cache[19] || (_cache[19] = ($event: any) => (_ctx.expandLinks = !_ctx.expandLinks))
                }, [
                  _createVNode(_component_ion_icon, {
                    slot: "icon-only",
                    icon: _ctx.menu
                  }, null, 8, ["icon"])
                ]),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.links, (link, idx) => {
                  return _withDirectives((_openBlock(), _createElementBlock("div", {
                    class: "guide-link",
                    key: idx,
                    onClick: ($event: any) => (_ctx.scrollTop(link.destPage))
                  }, _toDisplayString(idx + 1), 9, _hoisted_19)), [
                    [_vShow, _ctx.expandLinks]
                  ])
                }), 128))
              ], 512), [
                [_vShow, false]
              ])
            ], 512), [
              [_vShow, !_ctx.isFullScreen]
            ])
          ])
        ]),
        _: 1
      }, 8, ["class"])
    ]),
    _: 1
  }))
}